import { Skeleton } from "@mui/material";
import React from "react";

export const SkeletonText = ({
  loading = false,
  text = "",
  style = {},
  customValue = "",
}) => {
  if (loading) {
    return (
      <div style={{ ...style, display: "flex" }}>
        {customValue ? `${customValue} ` : ""}
        <Skeleton
          variant="text"
          sx={{ flex: 1, fontSize: style.fontSize || "16px" }}
        />
      </div>
    );
  }
  return <p style={style}>{customValue ? `${customValue} ${text}` : text}</p>;
};
